import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { usePrevious } from 'lib/core/hooks'
import { Toast } from 'lib/ui'
import { getCartId } from 'lib/core/data/quote/cartId/selectors'
import { getPlaceOrder, getErrorMessage } from 'lib/core/data/quote/placeOrderNext/selectors'
import { getPlaceOrder as getPlaceOrderRest, getErrorMessage as getErrorMessageRest } from 'lib/core/data/quote/placeOrder/selectors'

export const NotificationHandler = () => {
  const history = useHistory()
  const cartId = useSelector(getCartId)
  const placeOrder = useSelector(getPlaceOrder(cartId))
  const placeOrderRest = useSelector(getPlaceOrderRest(cartId))
  const errorMessageGraphQL = useSelector(getErrorMessage(cartId))
  const errorMessageRest = useSelector(getErrorMessageRest(cartId))

  const { isFetching: isFetchingGraphQL, isSuccess: isSuccessGraphQL, isFailure: isFailureGraphQL } = placeOrder
  const { isFetching: isFetchingRest, isSuccess: isSuccessRest, isFailure: isFailureRest } = placeOrderRest

  const isFetching = isFetchingGraphQL || isFetchingRest
  const isSuccess = isSuccessGraphQL || isSuccessRest
  const isFailure = isFailureGraphQL || isFailureRest
  const message = errorMessageGraphQL ?? errorMessageRest
  const prevIsFetching = usePrevious(isFetching)

  useEffect(() => {
    const isFetchingChanged = !!prevIsFetching && !isFetching

    if (isFetchingChanged && isFailure) {
      Toast.toastFailure({ message })
    }

    if (isFetchingChanged && isSuccess) {
      // TODO: move this somewhere else.
      history.push('/checkout/success')
    }
  }, [
    isFetching,
    isFailure,
    isSuccess,
    prevIsFetching,
    message,
    history
  ])

  return null
}
